import { render, staticRenderFns } from "./GenerateApiKeysButton.vue?vue&type=template&id=d2867b4e&scoped=true"
import script from "./GenerateApiKeysButton.vue?vue&type=script&lang=js"
export * from "./GenerateApiKeysButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2867b4e",
  null
  
)

export default component.exports